// React & Redux
import React from 'react';
import { useSelector } from 'react-redux';
// External UI Libraries
import Button from '@dtci/spellbook/Button';
// Components
import { DateMathCalculationsGrid } from './grid';
import { DetailsModal } from 'datastage/components/DetailsModal';
import { Pagination } from 'datastage/components/Pagination';
// Hooks & Actions
import { useDateMathActions } from 'datastage/store/dateMath/useDateMath';
import { useDateMathCalculationsActions } from 'datastage/store/dateMathCalculations/useDateMathCalculations';

/**
 * Date Match Calculations Modal
 *
 * Features:
 * - Displays a modal with date math calculations for a selected job
 * - Handles closing the modal and triggering refresh via refreshDateMath flag
 *
 * @returns {JSX.Element}
 */
export const DateMatchCalculationsModal = () => {
    const { showCalculations, selectedJob, totalPages, currentPage } = useSelector(
        (state) => state.dateMathCalculations,
    );
    const { clearDateMathCalculations } = useDateMathCalculationsActions();
    const { updateDateMath } = useDateMathActions();

    // Handle closing the modal and triggering refresh via flag pattern
    const onCloseMemoModal = () => {
        clearDateMathCalculations();
        // Trigger refresh via the refreshDateMath flag
        updateDateMath({ refreshDateMath: true });
    };

    return (
        <DetailsModal
            isOpen={showCalculations}
            onClose={onCloseMemoModal}
            modalHeader={`Date Math Calculations for Job: ${selectedJob?.id}`}
            footer={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    {/* Center - Pagination */}
                    <div style={{ flexGrow: 1, textAlign: 'center' }}>
                        <Pagination
                            pageCount={totalPages}
                            onPageChange={(e) => 'handlePageChange(e.selected)'}
                            previousLabel="←"
                            nextLabel="→"
                            forcePage={currentPage}
                        />
                    </div>
                    {/* Right Side - Close Button */}
                    <div>
                        <Button
                            sizeType="small"
                            styleType="link"
                            iconType="fa-solid fa-close"
                            onClick={onCloseMemoModal}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            }
        >
            <DateMathCalculationsGrid />
        </DetailsModal>
    );
};
